module.exports = __webpack_public_path__ + "static/Treff_Kommunikationsort-56a12d4525536a2cc47ee6654d52348f.png";